module.exports = __webpack_public_path__ + "static/media/thedesignofeverydaythings.f2c4f9f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/finals/books/thedesignofeverydaythings.jpg
// module id = 299
// module chunks = 0